import React from 'react'
import PageTitle from '../../components/PageTitle';
import { useContactTemplate } from '../../hooks/templates/useContactTemplate';
import ContactMainSection from './components/ContactMainSection';

const Contact = () => {
    useContactTemplate();
  return (
    <>
    <PageTitle title="Contact Us" />
    <ContactMainSection />
    </>
  )
}

export default Contact